import TopNavComponent from "./views/components/TopNavComponent";
import FooterComponent from "./views/components/FooterComponent";
import ContactPage from "./views/pages/ContactPage";
import Router from "./views/pages/Router";

export default function App() {
  return (
   <Router/>
  )
}
